import React, { Component } from 'react';
import Container from 'react-bootstrap/esm/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { MyContext, MyGlobal, MyHeading, MyAlert } from '../../GlobalContext';
import { Link } from 'react-router-dom';
import * as MySound from '../../MySound';


export class FirstCount_ConfirmLocation extends Component {
    static displayName = FirstCount_ConfirmLocation.name;

    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            alertMessage: "",
            selectedStocktake: "",
            selectedStocktakeLocationDetails: "",
            selectedLocationBarcode: "",
            selectedLocationData: "",
            scannedBarcode: "",
            startTime: "",
            travelTimeInSeconds: 0,
            timerStarted: false,
            previouspage: "FirstCount_ConfirmLocation",
            locationId: 0
        };
        this.history = props.history;
    }

    componentDidMount() {

        if (!MyGlobal.selected_stocktake) {
            this.setState({ alertMessage: "Please select a Stocktake" });
            return;
        }

        var selectedStocktakeParsedData = JSON.parse(MyGlobal.selected_stocktake);
        if (selectedStocktakeParsedData) {
            this.state.selectedStocktake = selectedStocktakeParsedData;
        }

        if (!this.state.selectedStocktake.stocktakeId || this.state.selectedStocktake.stocktakeId === "") {
            this.setState({ alertMessage: "Please select a Stocktake" });
            return;
        }


        if (!MyGlobal.stocktake_loc_details) {
            this.setState({ alertMessage: "Failed to load stocktake location details" });
            return;
        }

        var stocktakeLocationParsedData = JSON.parse(MyGlobal.stocktake_loc_details);
        if (stocktakeLocationParsedData) {
            this.state.selectedStocktakeLocationDetails = stocktakeLocationParsedData;
        }

        this.setState({ startTime: new Date(), timerStarted: true });
        this.refs.selectedLocationInput.focus();
        this.getNextLocation();
    }
    goto(page) {
        this.history.push(page);
    }

    prefixBarcodeSegmentWithZero(barCodeSegment) {

        if (barCodeSegment.length == 1) {
            barCodeSegment = "0" + barCodeSegment;
        }
        return barCodeSegment;
    }

    //validateBarcode() {
    //    this.setState({ alertMessage: "" });
    //    this.state.scannedBarcode = this.state.scannedBarcode.trim();

    //    //if (this.state.selectedLocationBarcode.trim().toLowerCase() !== this.state.scannedBarcode.toLowerCase()) {
    //    //    MySound.play(MySound.Sound.stop);
    //    //    this.setState({ alertMessage: "Wrong Location" });
    //    //}
    //    //else {
    //        MyGlobal.isStockCounted = "false";
    //        if (this.state.timerStarted === true) {
    //            var currentTime = new Date();
    //            var travelledTime = (currentTime - this.state.startTime) / 1000;

    //            this.state.travelTimeInSeconds = travelledTime;
    //            this.state.timerStarted = false;
    //        }

    //        MySound.play(MySound.Sound.next);

    //        this.history.push({
    //            pathname: 'FirstCount_ConfirmQty',
    //            state: this.state
    //        });
    //   // }
    //}

    getNextLocation() {
        this.setState({ loading: true });
        if (!this.state.selectedStocktake || !this.state.selectedStocktake.stocktakeId) {
            this.setState({ loading: false });
            this.setState({ alertMessage: "Error loading Stocktake details" });
            return;
        }

        const getNextLocationRequestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                StocktakeId: this.state.selectedStocktake.stocktakeId,
                RowLocation: this.state.selectedStocktakeLocationDetails.rowLocation,
                ColumnLocation: this.state.selectedStocktakeLocationDetails.columnLocation,
                LocationSortOrder: this.state.selectedStocktakeLocationDetails.sortOrder === "true" ? true : false,
                UseColumnLocation: this.state.selectedStocktakeLocationDetails.useColumnLocation,

            })
        };
        fetch('api/Stocktake/GetNextLocation', getNextLocationRequestOptions)
            .then(async response => {
                this.setState({ loading: false });
                // check for error response
                if (!response.ok) {
                    const errorText = await response.text();
                    this.setState({ alertMessage: "Failed to load location details!! " + errorText });
                }
                else {
                    const isJson = response.headers.get('content-type')?.includes('application/json');
                    const apiResponse = isJson ? await response.json() : null;
                    if (apiResponse) {
                        const data = apiResponse.data;
                        if (apiResponse.success) {
                            if (data.responseDescription === "No Data") {
                                this.setState({ alertMessage: "Row complete, no more locations" });
                            }
                            else {                             
                                var locationBarcode = data.rowItem.locationRow.trim() + "-" + this.prefixBarcodeSegmentWithZero(data.rowItem.locationColumn.toString()) + "-" + this.prefixBarcodeSegmentWithZero(data.rowItem.locationLevel.toString()) + "-" + this.prefixBarcodeSegmentWithZero(data.rowItem.locationTray.toString());
                                this.setState({ locationId: data.rowItem.locationID });
                                this.setState({ selectedLocationBarcode: locationBarcode, selectedLocationData: data });
                            }
                        }
                        else {
                            this.setState({ alertMessage: "Failed to load location details!!  " + apiResponse.errorMessage });
                        }
                    }
                    else {
                        this.setState({ alertMessage: "Failed to load location details!!" });
                    }

                }
            })
            .catch(error => {
                this.state.loading = false;
                this.setState({ alertMessage: error });
            });


    }

    validateBarcode() {
        this.setState({ loading: true });

        fetch(`api/Enquiry/ValidateLocation?warehouseId=${MyGlobal.warehouse}&locationBarcode=${this.state.scannedBarcode}`)
            .then(async response => {
                this.setState({ loading: false });
                // check for error response
                if (!response.ok) {
                    const errorText = await response.text();
                    console.error(errorText);
                    this.setState({ alertMessage: "Failed to validate location!!" });
                    MySound.play(MySound.Sound.stop);
                }
                else {
                    const isJson = response.headers.get('content-type')?.includes('application/json');
                    const apiResponse = isJson ? await response.json() : null;
                    if (apiResponse) {
                        var currentLocationId = this.state.locationId;
                        if (currentLocationId !== apiResponse.locationId) {
                                MySound.play(MySound.Sound.stop);
                                this.setState({ alertMessage: "Wrong Location" });
                            }
                            else {
                                MyGlobal.isStockCounted = "false";
                                if (this.state.timerStarted === true) {
                                    var currentTime = new Date();
                                    var travelledTime = (currentTime - this.state.startTime) / 1000;

                                    this.state.travelTimeInSeconds = travelledTime;
                                    this.state.timerStarted = false;
                                }

                                MySound.play(MySound.Sound.next);

                                this.history.push({
                                    pathname: 'FirstCount_ConfirmQty',
                                    state: this.state
                                });
                            }
                    }
                    else {
                        this.setState({ alertMessage: "Failed to validate location!!" });
                    }
                }
            })
            .catch(error => {
                this.setState({ alertMessage: error });
            });
    }

    render() {

        let alertMessage = this.state.alertMessage;
        alertMessage = alertMessage != "" ? <MyAlert variant="danger">{alertMessage}</MyAlert> : "";

        let selectedLocationHtml = this.state.loading
            ? <p><em>Loading...</em></p>
            : <label>{this.state.selectedLocationBarcode} </label>;

        const handlebarcodeKeyPress = e => {
            if (e.keyCode === 13 || e.charCode === 13 || e.which === 13) {
                this.validateBarcode();
            }
        };

        return (
            <div>
                <Container>
                    <Row className="mb-3">
                        <Col xs={9}><h5>First Count - Confirm Location</h5></Col>
                        <Col xs={3}><button type="button" className="btn btn-success col-12 mb-2" onClick={() => { this.goto('FirstCount_Location'); }} >
                            Back
                        </button></Col>
                    </Row>
                    <Row className="mb-3">
                        <Col>{alertMessage}</Col>
                    </Row>
                    <Row className="mb-3">
                        <Col xs={12}>
                            <label> Scan Location</label>
                            <br />
                            {selectedLocationHtml}
                        </Col>
                    </Row>
                    <Row className="mb-3">
                        <Col xs={12}>
                            <input ref="selectedLocationInput" className="form-control"
                                onChange={(e) => {
                                    this.setState({ scannedBarcode: e.target.value });
                                }} onKeyPress={handlebarcodeKeyPress} readOnly={this.state.loading} >
                            </input>


                        </Col>
                    </Row>
                    <Row>
                        <Col xs={12}>
                            <button type="button" className="btn btn-success col-12 mb-2" onClick={() => { this.validateBarcode(); }}>Next</button>
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={12}>
                            <Link className="btn btn-success col-12 mb-2" to={{ pathname: "../AdhocCount/AdhocCount_Location", state: this.state }}>Adhoc Count</Link>
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={12}>
                            <Link className="btn btn-success col-12 mb-2" to={{ pathname: "../AddNew/AddNew_ProductLocation", state: this.state }}>Add Extra</Link>
                        </Col>
                    </Row>
                </Container>
            </div>)
    }


}
